export interface UserFormValue {
  name: string;
  lastname: string;
  email: string;
  // Sent as `profile`: the role select holds the profile string ('admin' | 'superadmin')
  roleId: number | string | null;
  dni: string | null;
  companyId: number | null;
  phone: string | null;
  // Optional initial password (create only). Empty = backend falls back to the DNI.
  password?: string | null;
  passwordConfirmation?: string | null;
}
